import {
  Activity,
  Award,
  BellRing,
  Building2,
  FileBarChart,
  FolderKanban,
  GitBranch,
  Inbox,
  LayoutDashboard,
  Settings,
  Sparkles,
  Trophy,
  TrendingUp,
  Users,
  UsersRound,
  Wallet,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  label: string;
  path: string;
  icon: LucideIcon;
}

export const NAV_ITEMS: NavItem[] = [
  { label: "Executive Overview", path: "/", icon: LayoutDashboard },
  { label: "Revenue Race", path: "/revenue-race", icon: Trophy },
  { label: "Super Bonus", path: "/super-bonus", icon: Award },
  { label: "Revenue", path: "/revenue", icon: TrendingUp },
  { label: "Clients", path: "/clients", icon: Users },
  { label: "Operations", path: "/operations", icon: Activity },
  { label: "People", path: "/people", icon: UsersRound },
  { label: "Talent", path: "/talent", icon: GitBranch },
  { label: "Finance", path: "/finance", icon: Wallet },
  { label: "Departments", path: "/departments", icon: Building2 },
  { label: "Projects", path: "/projects", icon: FolderKanban },
  { label: "AI Insights", path: "/ai-insights", icon: Sparkles },
  { label: "Alerts Center", path: "/alerts", icon: BellRing },
  { label: "Executive Inbox", path: "/inbox", icon: Inbox },
  { label: "Reports", path: "/reports", icon: FileBarChart },
  { label: "Settings", path: "/settings", icon: Settings },
];
